import { Header } from 'modules/Header'

export const HeaderContainer = () => (
  <>
    <Header icon="menu" iconText="Menu" title="MASCare" />
  </>
)
